import React from "react";

class EduPricing extends React.Component {
    render() {
        return (
            <div className="margin-t-xl" style={{ textAlign: "center" }}>
                <img
                    alt="NounPro"
                    src={require("../../img/for_edu/nounpro_edu_apple@2x.png")}
                    width="50"
                    height="50"
                />
                <h3 className="font-xxlarge">NounPro</h3>
                <h3 className="font-large margin-b-m">for Education</h3>
                <div className="price-container">
                    <div className="price-sign-style">
                        <div className="price-dollar-sign">$</div>
                        <div className="price-dollars-bold">19</div>
                        <div className="price-cents-underline price-pro">
                            99
                        </div>
                        <div className="price-stacked-type">billed yearly</div>
                    </div>
                    <div
                        className="font-small color-grey margin-t-m"
                        style={{ textDecoration: "line-through" }}
                    >
                        $39.99 per yr
                    </div>
                </div>

                <div
                    style={{
                        background: "#FFFFFF",
                        color: "#000000",
                        border: "solid 3px #f2f2f2",
                        maxWidth: "350px",
                        margin: "24px auto"
                    }}
                >
                    <h3 style={{ background: "#F2f2f2", padding: "8px" }}>
                        What you get
                    </h3>
                    <ul className="display-flex padding-m margin-t-s margin-b-s">
                        <li className="pricing-features col-lg-4 col-sm-4 col-xs-4">
                            <img
                                className="pricing-illustration"
                                src={require("../../img/pricing/pricing_illustration_lots_of_icons@2x.png")}
                                alt="Over 1 Million Icons"
                                width="50"
                                height="50"
                            />
                            <div>
                                Over 1<br /> Million Icons
                            </div>
                        </li>
                        <li className="pricing-features col-lg-4 col-sm-4 col-xs-4">
                            <img
                                className="pricing-illustration"
                                src={require("../../img/pricing/pricing_illustration_royaltyfree_licenses@2x.png")}
                                alt="Royalty-free Licenses"
                                width="50"
                                height="50"
                            />
                            <div>
                                Royalty—free
                                <br /> Licenses
                            </div>
                        </li>
                        <li className="pricing-features col-lg-4 col-sm-4 col-xs-4">
                            <img
                                className="pricing-illustration"
                                src={require("../../img/pricing/pricing_illustration_change_color@2x.png")}
                                alt="Change Color"
                                width="50"
                                height="50"
                            />
                            <div>Customize Icon</div>
                        </li>
                    </ul>
                    <h3 style={{ background: "#F2f2f2", padding: "8px" }}>
                        Plus all our apps for
                    </h3>
                    <ul
                        className="billing-list-of-apps row margin-t-s margin-b-s"
                        style={{ textAlign: "left" }}
                    >
                        <li className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <ul>
                                <li className="app-list-app display-flex">
                                    <img
                                        src={require("../../img/mac_app/apple@2x.png")}
                                        alt="Noun Project for Mac"
                                        title="Drag and drop from your desktop."
                                        width="18"
                                        height="18"
                                    />{" "}
                                    Mac Users
                                </li>
                                <li className="app-list-app display-flex">
                                    <img
                                        src={require("../../img/for_windows/appicon_illustrator@2x.png")}
                                        alt="Noun Project for Adobe Illustrator"
                                        width="18"
                                        height="18"
                                    />{" "}
                                    Adobe Illustrator
                                </li>
                                <li className="app-list-app display-flex">
                                    <img
                                        src={require("../../img/for_windows/appicon_photoshop@2x.png")}
                                        alt="Noun Project for Adobe Photoshop"
                                        width="18"
                                        height="18"
                                    />{" "}
                                    Adobe Photoshop
                                </li>
                                <li className="app-list-app display-flex">
                                    <img
                                        src={require("../../img/for_windows/appicon_indesign@2x.png")}
                                        alt="Noun Project for Adobe InDesign"
                                        width="18"
                                        height="18"
                                    />{" "}
                                    Adobe InDesign
                                </li>
                            </ul>
                        </li>
                        <li className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <ul>
                                <li className="app-list-app display-flex">
                                    <img
                                        src={require("../../img/for_windows/logo_slides_128px.png")}
                                        alt="Noun Project for Google Slides"
                                        width="18"
                                        height="18"
                                    />{" "}
                                    Google Slides
                                </li>
                                <li className="app-list-app display-flex">
                                    <img
                                        src={require("../../img/for_windows/logo_docs_128px.png")}
                                        alt="Noun Project for Google Docs"
                                        width="18"
                                        height="18"
                                    />{" "}
                                    Google Docs
                                </li>
                                <li className="app-list-app display-flex">
                                    <img
                                        src={require("../../img/for_windows/Microsoft_PowerPoint_2013_logo.svg")}
                                        alt="Noun Project for Microsoft PowerPoint"
                                        width="18"
                                        height="18"
                                    />{" "}
                                    Microsoft PowerPoint
                                </li>
                                <li className="app-list-app display-flex">
                                    <img
                                        src={require("../../img/for_windows/Microsoft_Word_2013_logo.svg")}
                                        alt="Noun Project for Microsoft Word"
                                        width="18"
                                        height="18"
                                    />{" "}
                                    Microsoft Word
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

module.exports = EduPricing;
